import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@wds/grid';
import { Box } from '@wds/box';
import { Typography } from '@wds/typography';
import useStyles from '../styles';
import { trimStringTo } from '~app/pages/AppsDirectory/components/utils';

export const AppDetailsFeatures = ({ featureList }) => {
  const { textContainer } = useStyles();

  return (
    <Grid noBleeds>
      <Grid.Item>
        <Box className={textContainer}>
          <ul>
            {featureList.map(feature => (
              <li key={feature}>
                <Typography weight="medium">{trimStringTo(200, feature)}</Typography>
              </li>
            ))}
          </ul>
        </Box>
      </Grid.Item>
    </Grid>
  );
};

AppDetailsFeatures.propTypes = {
  featureList: PropTypes.arrayOf(PropTypes.string),
};

AppDetailsFeatures.defaultProps = {
  featureList: [],
};

export default AppDetailsFeatures;
